import React from "react";
import { Nav } from "./Nav";


export function NavBar(props:{ toggleSideNav:()=>void,hideDrawer:boolean }) {
  return <Nav hideDrawer={props.hideDrawer} toggleSideNav={props.toggleSideNav} />;
}

